module.exports = __webpack_public_path__ + "static/media/betennelse.4d7de7a1.m4a";